export const loadApplePaySdk = () => {
  return new Promise((resolve, reject) => {
    const APPLE_PAY_SDK_URL = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';

    // Resolve immediately if the script is already loaded
    if (window.ApplePaySession) {
      return resolve();
    }

    const existingScript = document.querySelector(`script[src="${APPLE_PAY_SDK_URL}"]`);

    // If script tag exists, it might be loading; listen for it to finish.
    if (existingScript) {
      existingScript.addEventListener('load', resolve);
      existingScript.addEventListener('error', reject);
      return;
    }

    // Otherwise, create and inject the script tag.
    const script = document.createElement('script');
    script.src = APPLE_PAY_SDK_URL;
    script.async = true;
    script.crossOrigin = true;
    script.onload = resolve;
    script.onerror = reject;
    document.head.appendChild(script);
  });
};

export const isApplePayAvailable = async () => {
  try {
    await loadApplePaySdk();
    return !!(window.ApplePaySession && window.ApplePaySession.canMakePayments());
  } catch {
    console.warn('Apple Pay is not available');
    return false;
  }
};
